var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-viewer"},[_c('img',{ref:"imageElement",staticClass:"d-none",attrs:{"src":_vm.getImageSrc,"alt":_vm.fileDetails.itemName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }